import { inject } from 'aurelia';
import { websiteShortCode } from '../environment';
import { ApiService } from './api-service';

@inject(ApiService)
export class CustomerService {
    path = 'User';
    idPath = this.path + '/';

    constructor(private api: ApiService) { }

    async updateInformation(data) {
        data.websiteShortCode = websiteShortCode();
        return await this.api.doPut(this.path + '/updateInformation', data);
    }

    async requestPasswordReset(data) {
        data.websiteShortCode = websiteShortCode();
        return await this.api.doPost('requestResetPassword', data);
    }

    async destroyUserCartProducts(id = 0, orderId = 0) {
        return await this.api.doDelete(`${this.path}/${id}/DestroyUserCartProducts/${orderId}`);
    }

    async getUserCartProducts() {
        return await this.api.doGet(`${this.path}/GetUserCartProducts`);
    }

    async getUserCartProductsCount() {
        return await this.api.doGet(`${this.path}/cart/count`);
    }

    async getNotifications(count = 20) {
        return await this.api.doGet(`Notification/GetLatestNotification?count=${count}`);
    }

    async getNotificationCount() {
        return await this.api.doGet('Notification/unreadCount');
    }
}
